import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "h-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "h5 mb-3" }, "Odběratel", -1)
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = { class: "mt-1" }
const _hoisted_6 = { class: "mt-1" }
const _hoisted_7 = { class: "mt-1" }
const _hoisted_8 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_9 = {
  key: 1,
  class: "mt-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.customer.name), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.customer.street), 1),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.customer.zip) + " " + _toDisplayString(_ctx.customer.city), 1),
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.customer.country), 1)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", null, "IČO: " + _toDisplayString(_ctx.customer.companyId), 1),
      (_ctx.customer.vatPayer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, "DIČ: " + _toDisplayString(_ctx.customer.vatId), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, "Neplátce DPH"))
    ])
  ]))
}